// extracted by mini-css-extract-plugin
module.exports = {"root":"Cta_root__bJpu-","title":"Cta_title__3r7eh","btnWrap":"Cta_btnWrap__3iyxA"};